export default {
  // primary: '#4caf50',
  // secondary: '#4caf50',
  primary: '#ff9900',
  secondary: '#ff9900',
  tertiary: '#495057',
  accent: '#82B1FF',
  error: '#f55a4e',
  info: '#00d3ee',
  success: '#fb8c00',
  warning: '#ffa21a'
}
